import createInstance from '@emotion/css/create-instance';
import { prefixer } from 'stylis';
import { convertInvalidUnitlessValuesToPixels } from './convertInvalidUnitlessValuesToPixels';
import { fixCss } from './fixCss';

// https://emotion.sh/docs/@emotion/cache#stylisplugins
const defaultStylisPlugins = [prefixer];

export const createCustomInstance = (key: string) => {
  // See https://emotion.sh/docs/@emotion/css#multiple-instances-in-a-single-app-example
  const instance = createInstance({
    key,
    stylisPlugins: [
      // In emotion 9, unitless values were allowed and automatically
      // transformed to pixels where they would be invalid. For backwards
      // compatibility, that behavior is ported here.
      convertInvalidUnitlessValuesToPixels,
      ...defaultStylisPlugins,
    ],
  });

  // Disable SSR pseudo-selector checks.
  // See https://github.com/emotion-js/emotion/issues/1105#issuecomment-557726922
  instance.cache.compat = true;

  // eslint-disable-next-line @typescript-eslint/unbound-method -- members are not context aware
  instance.css = fixCss(instance.css);

  return instance;
};
